import { showOnlyThisElement } from "./showOnlyThisElement";
import { changeDisplayBasedOnParams } from "./changeDisplayBasedOnParams";
import { getParams } from "../utils";
import { params } from "./handleMarkpage";
import { yaml } from "../processMarkdown/yaml";
import { handleTags } from "./searchBar/handleTags";
import { handleSelectElements } from "./searchBar/handleSelectElements";

export function handleClicks(baseURL, hash, markpageData) {
	// On détecte les clics sur les liens
	const links = document.querySelectorAll(".navigationLink");
	links.forEach(function (link) {
		let listenerElement = link;
		if (
			link.parentElement.nodeName == "H3" ||
			link.parentElement.parentElement.nodeName == "H3"
		) {
			listenerElement = link.parentElement;
		}
		listenerElement.addEventListener("click", function (event) {
			// Empêche le comportement par défaut d'ouverture du lien et récupère au contraire le contenu du lien
			event.preventDefault();
			const linkURL = link.href.replace(link.hash, "");
			let newURL;
			if (linkURL == baseURL || linkURL + "index.html" == baseURL) {
				// Si le lien est un lien vers la page d'accueil, on enlève les paramètres "sec" et "subsec" de l'URL et on affiche tout le contenu
				newURL = baseURL + "#" + hash;
				delete params.sec;
				delete params.subsec;
				showOnlyThisElement(undefined, "sections");
				showOnlyThisElement(undefined, "subsections");
			} else {
				// Sinon, on récupère les paramètres "sec" et "subsec" du lien cliqué et on les ajoute à l'URL, puis on affiche la section ou la sous-section correspondante
				const linkURLWithoutBase = linkURL.replace(baseURL, "");
				const linkParams = getParams(linkURLWithoutBase, hash);
				Object.assign(params, linkParams);
				if (!("subsec" in linkParams)) {
					params.subsec = 1;
				}
				// Changement de l'historique de l'URL
				newURL =
					baseURL +
					"?" +
					Object.keys(params)
						.map(function (key) {
							return key + "=" + encodeURIComponent(params[key]);
						})
						.join("&") +
					"#" +
					hash.replace("?footnote", "");
			}
			history.pushState({ path: newURL }, "", newURL);
			changeDisplayBasedOnParams(params, markpageData);
		});
	});

	// Gestion des boutons de filtres dans Lightpad
	if (yaml.lightpad) {
		handleTags();
		handleSelectElements();
	}

	// Possibilité de se déplacer à gauche ou à droite avec un clic maintenu sur la souris
	// (Dans le mode "pad")
	if (yaml.pad) {
		const innerBox = document.querySelector("#innerBox");
		innerBox.addEventListener("mousedown", function (event) {
			// Liste de tags à ignorer car ils représentent des éléments potentiellement interactifs
			const ignoredTags = [
				"IMG",
				"IFRAME",
				"BUTTON",
				"INPUT",
				"TEXTAREA",
				"SELECT",
				"LABEL",
				"VIDEO",
				"AUDIO",
				"CANVAS",
			];
			// On ne fait rien si on clique sur un élément potentiellement interactif ou si le clic est à l'intérieur des contenus des colonnes
			// Pour les liens "A", on traite différement les titres des capsules, sur lesquelles on peut cliquer pour se déplacer avec la souris.
			if (
				ignoredTags.includes(event.target.tagName) ||
				event.target.closest(".subSectionContent, .noSubSections") ||
				(event.target.tagName == "A" &&
					event.target.parentElement.tagName != "H3")
			) {
				return;
			}
			let startX = event.clientX;
			const isModeLightpadNoColums =
				document.body.classList.contains("noColumns");
			let scrollableElement = isModeLightpadNoColums
				? document.body.querySelector("#content")
				: document.body.querySelector("#innerBox");

			let scrollLeft = scrollableElement.scrollLeft;
			let isDragging = true;

			// On empêche la sélection de texte au moment de relâcher la souris
			event.preventDefault();

			function onMouseMove(e) {
				if (!isDragging) return;
				let deltaX = e.clientX - startX;
				scrollableElement.scrollTo({
					left: scrollLeft - deltaX,
					behavior: "auto",
				});
			}

			function onMouseUp() {
				isDragging = false;
				innerBox.removeEventListener("mousemove", onMouseMove);
				innerBox.removeEventListener("mouseup", onMouseUp);
			}

			innerBox.addEventListener("mousemove", onMouseMove);
			innerBox.addEventListener("mouseup", onMouseUp);
		});
	}
}
